import { Box, styled } from "@mui/material"

export const ExportIconWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  minWidth: "56px",
  height: "56px",
  borderRadius: "50%",
  cursor: "pointer",
  border: `1px solid ${theme.palette.primary.main}`,
  padding: 0,
  fontFamily: "inherit",
  ":hover": {
    transition: "background .3s",
    background: theme.palette.mockup.primary90,
  },
  ":focus-visible": {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
  transition: "background .3s",
  background: theme.palette.common.white,
}))

export const BoxIconTrash = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "20px",
  right: "20px",
  display: "flex",
  width: "32px",
  height: "32px",
  borderRadius: "50%",
  flexWrap: "wrap",
  border: `1.5px solid ${theme.palette.primary.main}`,
  color: `${theme.palette.primary.main}`,
  cursor: "pointer",
  ":hover": {
    transition: "background .5s",
    background: theme.palette.mockup.primary95,
  },
}))

export const GradientDivider = styled(Box)(() => ({
  height: "1px",
  margin: "4px 12px",
  background:
    "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.12) 20%, rgba(255,255,255,0.12) 80%, transparent 100%)",
}))
